export const LogoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    fill="none"
    viewBox="0 0 45 45"
  >
    <path
      fill="url(#paint0_linear_1463_3992)"
      d="M35.61 5.41C31.213 1.136 25.13.226 22.637.305c-4.644 0-9.2 1.465-13.255 3.942C5.328 6.724.62 12.369.205 18.293c-.414 5.925 1.483 11.461 6.933 15.813 5.45 4.352 14.737 8.079 19.337 8.66 4.6.582 9.047-.754 12.514-3.64 3.466-2.887 5.711-7.347 5.711-12.646 0-5.3-3.597-15.727-9.09-21.07z"
    />
    <path
      fill="#FEFFFA"
      d="M31.447 29.541h-7.441c-.06 0-.09-.037-.09-.112l.023-15.814c0-.06.03-.09.09-.09h7.395c.06 0 .09.037.09.112v2.574c0 .06-.03.09-.09.09h-4.72v3.597h4.72c.06 0 .09.03.09.09l.023 2.607c0 .06-.03.09-.09.09h-4.744v4.024h4.744c.06 0 .09.038.09.112v2.63c0 .06-.03.09-.09.09zM19.112 29.541h-2.596c-.068 0-.101-.037-.101-.112V16.301h-2.99c-.075 0-.113-.037-.113-.112l.023-2.574c0-.06.03-.09.09-.09h8.744c.083 0 .124.03.124.09v2.574c0 .075-.03.112-.09.112H19.18l.022 13.128c0 .075-.03.112-.09.112z"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1463_3992"
        x1="11.794"
        x2="55.945"
        y1="-6.8"
        y2="58.549"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ED2F2F" />
        <stop
          offset="1"
          stopColor="#871B1B"
        />
      </linearGradient>
    </defs>
  </svg>
)
